import { UserInfos } from "./user-infos.model";

export class UserStateModel
{
  isLogged: boolean;
  token: string;
  langueCode: string;
}  
